module.exports = __webpack_public_path__ + "img/source04_3.4d2e8c20.png";